export var RewardStatusEnum;
(function (RewardStatusEnum) {
    RewardStatusEnum["ACTIVE"] = "ACTIVE";
    RewardStatusEnum["DRAFT"] = "DRAFT";
    RewardStatusEnum["EXECUTION_LIMIT_REACHED"] = "EXECUTION_LIMIT_REACHED";
    RewardStatusEnum["EXPIRED"] = "EXPIRED";
    RewardStatusEnum["POUSED"] = "POUSED";
    RewardStatusEnum["PROCESSING"] = "PROCESSING";
})(RewardStatusEnum || (RewardStatusEnum = {}));
//# sourceMappingURL=reward-status.enum.js.map